import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import FolderIcon from '@material-ui/icons/Folder';
import DeleteIcon from '@material-ui/icons/DeleteOutline';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import { Grid } from '@material-ui/core';

import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import AttachmentIcon from '@material-ui/icons/Attachment';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import Highlighter from 'react-highlight-words';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(2),
    paddingLeft: theme.spacing(3),
    marginBottom: theme.spacing(1)
  },
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper
  },
  deleteButton: {
    color: theme.palette.danger.main
  },
}));

const DocumentList = (props) => {
  const {
    documents,
    handleFolderClick,
    handleDocumentClick,
    searchTerm,
    showDelete,
    handleDeleteClick
  } = props;

  const classes = useStyles();

  const toSearchArray = searchTerm && searchTerm !== '' ? [searchTerm] : [];

  const folders = documents.filter((x) => x.isFolder === true);
  const plainDocuments = documents.filter((x) => x.isFolder === false);

  return (
    <React.Fragment>
      <div className={classes.root}>
        <List component="nav" aria-label="folder">
          {folders &&
            folders.map((folder) => {
              return (
                <ListItem
                  button
                  key={folder}
                  onClick={() => handleFolderClick(folder)}
                >
                  <ListItemIcon>
                    <FolderIcon />
                  </ListItemIcon>
                  <ListItemText primary={folder.folderName} />
                </ListItem>
              );
            })}
        </List>
        <Divider />
        <List component="nav" aria-label="documents">
          {plainDocuments &&
            plainDocuments.map((document) => {
              return (
  

          <Grid container>
            <Grid item xs={9}>
            <ListItem
                  button
                  key={document}
                  onClick={() => handleDocumentClick(document)}
                >
                  <ListItemIcon>
                    <AttachmentIcon />
                  </ListItemIcon>
                  <ListItemText >
                    <Highlighter
                      highlightClassName="YourHighlightClass"
                      searchWords={toSearchArray}
                      textToHighlight={document.documentName}
                    />
                  </ListItemText>
                  </ListItem>
                  </Grid>

                  {showDelete &&  <Grid item xs={3}>
                <Button
                  startIcon={<DeleteIcon />}
                  className={classes.deleteButton}
                  onClick={() => handleDeleteClick(document)}
                >
                  Delete
                </Button>
            </Grid> }

            </Grid>
                 
           
              );
            })}
        </List>
      </div>
    </React.Fragment>
  );
};

export default DocumentList;
